import React, { Component } from 'react';
import './style.scss'
import Item from './components/Item'
import { connect } from 'react-redux'
import Actions from './components/Actions';
import {orderBy} from 'lodash';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {cloneDeep} from 'lodash';
import { updateSliderItemOrder, setLoaded } from '../../actions';
import SelectField from '../../../helpers/Fields/SelectField';
import PropTypes from 'prop-types';

class Sliders extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  constructor(props) {
    super(props);

    const items = props.items;

    let tmp_item = items.map(item => ({
      ...item, 
      order_x: isNaN(parseInt(item.order_x)) ? 0 : parseInt(item.order_x)
    }))

    this.state = {
      items: orderBy(tmp_item, ['order_x'], ['asc']),
      count_load: 0,
      selected_slides: []
    }
  }

  componentWillReceiveProps(nextProps){
    const {items} = nextProps;
    let tmp_item = items.map(item => ({
      ...item, 
      order_x: isNaN(parseInt(item.order_x)) ? 0 : parseInt(item.order_x)
    }))
    this.setState({
      items: orderBy(tmp_item, ['order_x'], ['asc'])
    })
  }

  onDragEnd = async (result) => {
    const {loadFileSpiner } = this.props;
    const { destination, source, type } = result;
    

		if(!destination){
			return;
		}

		if(destination.droppableId === source.droppableId && destination.index === source.index){
			return;
		}

    let items = cloneDeep(this.state.items); 
    const item = items[source.index];

    items.splice( source.index, 1);
    items.splice( destination.index, 0, item);
    this.props.updateSliderItemOrder(items.map((item, index) => ({id: item.id, order_x: index})));
    this.setState({items})
  }

  onChange = (value) => {
    this.props.onChangeSession(value)
  }

  setLoadImg = () => {
    const {items} = this.state;
    this.state.count_load++;
    if(this.state.count_load >= items.filter(_i => _i.type == 'image').length){
      this.props.setLoaded(true);
    }
  }

  onSelectedSlide = (v) => {
    this.setState({selected_slides: v})
  }
  

  render() {
    const {items, selected_slides} = this.state;
    const {formatMessage} = this.context;

    const count_imgs = items.filter(i => i.type == 'image').length;

    return (
      <div className="col-md-2 SliderSliders">
        <Actions 
          loadFileSpiner={this.props.loadFileSpiner} 
          selected_slides={selected_slides}
          onSelectedSlide={this.onSelectedSlide}
        />
        <div className="items">
          <DragDropContext
						onDragEnd={this.onDragEnd}
					>
            <Droppable droppableId="all-items" direction="vertical" type="items">
							{(provided) => (<div
							 ref={provided.innerRef}
							 {...provided.droppableProps}
							>
                {items.map((item, index) => <Item 
                  setLoadImg={this.setLoadImg} 
                  item={item} 
                  index={index} 
                  key={'slide-item' + item.id}
                  selected_slides={selected_slides}
                  onSelectedSlide={this.onSelectedSlide}
                />)}
								{provided.placeholder}
							</div>
							)}
						</Droppable>
          </DragDropContext>

        </div>
        {/* <div className="count-slide">
          <div className="count">{formatMessage('txtI')}:{count_imgs}</div>
          <div className="count">{formatMessage('txtT')}:{items.length}</div>
        </div> */}
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  items: state.slider.items,
  sessions: state.slider.sessions,
})

const mapDispatchToProps = {
  updateSliderItemOrder,
  setLoaded
}

export default connect(mapStateToProps, mapDispatchToProps)(Sliders)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Slider/components/Sliders/index.jsx